/**
 * Buton
 *
 * Projede onlarca yerde elle tekrarlanan primary / iptal / tehlike buton
 * kalıplarının tek bileşene alınmış hâli. Satır içi düzenle-sil ikilisi için
 * ActionButtons kullanılmaya devam edilir; bu bileşen form ve modal
 * butonları içindir.
 *
 * Props:
 *   tur    – 'primary' | 'ikincil' | 'tehlike' | 'sessiz'   (varsayılan primary)
 *   renk   – primary gradient rengi: 'violet' | 'cyan' | 'indigo' | 'emerald'
 *   blok   – true ise flex-1 (modal footer'ında yan yana iki buton için)
 *   Kalan tüm props (onClick, disabled, type…) <button>'a geçer.
 *
 * Kullanım:
 *   <Buton tur="ikincil" blok onClick={kapat}>Vazgeç</Buton>
 *   <Buton renk="violet" blok onClick={kaydet} disabled={!gecerli}>Randevu Oluştur</Buton>
 */

const GRADIENT = {
  violet:  'from-violet-600 to-fuchsia-700 shadow-violet-200',
  cyan:    'from-cyan-600 to-blue-700 shadow-cyan-200',
  indigo:  'from-indigo-600 to-violet-700 shadow-indigo-200',
  emerald: 'from-emerald-500 to-teal-600 shadow-emerald-200',
};

const TEMEL = 'px-8 py-3.5 rounded-2xl text-[10px] font-black uppercase tracking-widest leading-none ' +
              'transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed ' +
              'disabled:hover:translate-y-0 flex items-center justify-center gap-2';

export default function Buton({
  tur = 'primary',
  renk = 'violet',
  blok = false,
  className = '',
  children,
  ...props
}) {
  const gradient = GRADIENT[renk] || GRADIENT.violet;

  const stil = {
    primary: `bg-gradient-to-r ${gradient} text-white shadow-xl hover:-translate-y-0.5`,
    ikincil: 'bg-white border-2 border-gray-100 text-gray-400 hover:bg-gray-100 hover:text-gray-600',
    tehlike: 'bg-rose-50 border-2 border-rose-100 text-rose-500 hover:bg-rose-600 hover:text-white',
    sessiz:  'bg-gray-100 text-gray-600 hover:bg-gray-200',
  }[tur] || '';

  return (
    <button className={`${TEMEL} ${stil} ${blok ? 'flex-1' : ''} ${className}`} {...props}>
      {children}
    </button>
  );
}
